// Vars must be prefixed with `EPIC_CLIENT` so they get injected to the store
export const FEATURE_FLAGS_QUERY_STRING_ENABLED = 'EPIC_CLIENT_FEATURE_FLAGS_QUERY_STRING_ENABLED';
export const FEATURE_FLAGS_QUERY_STRING_KEY = 'ff';
export const FEATURE_FLAGS_ENVIRONMENT_VARIABLES_PREFIX = 'EPIC_CLIENT_FEATURE_FLAG';
